import { type JsonObject, UserWithRole } from '@utilities-one/api-sdk';
import { merge } from 'lodash';

export function mergePermissions(user: UserWithRole) {
  const rolePermissions = user.role?.permissions;
  const userPermissions = user.permissions;

  if (!rolePermissions || !userPermissions) return rolePermissions as JsonObject;

  return merge({}, rolePermissions, userPermissions) as JsonObject;
}
